import facetList from "./facetList";

function getTermFilterValue(field, fieldValue) {
  // We do this because if the value is a boolean value, we need to apply
  // our filter differently. We're also only storing the string representation
  // of the boolean value, so we need to convert it to a Boolean.

  // TODO We need better approach for boolean values
  if (fieldValue === "false" || fieldValue === "true") {
    return { [field]: fieldValue === "true" };
  }

  return { [`${field}`]: fieldValue };
}

function getTermFilter(filter) {
  if (filter.type === "any") {
    return {
      bool: {
        should: filter.values.map(filterValue => ({
          term: getTermFilterValue(filter.field, filterValue)
        })),
        minimum_should_match: 1
      }
    };
  } else if (filter.type === "all") {
    return {
      bool: {
        filter: filter.values.map(filterValue => ({
          term: getTermFilterValue(filter.field, filterValue)
        }))
      }
    };
  }
}

function getUnknownStatusFilter(filter) {
  return {
    bool: {
      must_not: {
        exists: {
          field: 'u_status',
        }
      }
    }
  };
}


function getHasImageFilter(filter) {
  return {
    bool: {
      must: {
        term: {
            u_has_image: true,
        }
        /*
        exists: {
          field: 'nombreDImage',
        }
        */
      }
    }
  };
}


export default function buildRequestFilter(filters) {
  if (!filters) return;

  filters = filters.reduce((acc, filter) => {
    if (facetList.includes(filter.field)) {
      return [...acc, getTermFilter(filter)];
    }
    if (['has_image'].includes(filter.field) && filter.values[0] !== 'false' && filter.values[0] !== false) {
      return [...acc, getHasImageFilter(filter)];
    }
    if (['unknown_status'].includes(filter.field) && filter.values[0] !== 'false' && filter.values[0] !== false) {
      return [...acc, getUnknownStatusFilter(filter)];
    }
    return acc;
  }, []);

  if (filters.length < 1) return;
  return filters;
}
